export const LINKED_CONTACT_TABLE_EMPTY = {
  CONTACTS: "No contacts yet.",
  COMPANIES: "No companies yet.",
  PROPERTIES: "No projects yet.",
};

export const PROPERTY_TASKS_TABLE_EMPTY = {
  SINGLE: "No single tasks yet.",
  RECURRING: "No recurring tasks yet.",
  COMPLETED: "No completed tasks yet.",
};

export const HOMEPAGE_ASSIGNED_TASKS_TABLE_EMPTY = {
  ACTIVE: "No active tasks yet.",
  FINISHED: "No finished tasks yet.",
};

export const ENTITY_LINKS_TABLE_EMPTY = {
  PROPERTIES: "No linked projects yet.",
  COMPANIES: "No linked companies yet.",
  CONTACTS: "No linked contacts yet.",
};

export function emptyTableMessageForLinkedContact(contactId, rowCount, message) {
  return contactId != null && rowCount === 0 ? message : null;
}
